import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { memo } from 'react';

/**
 *  `SelectableTabPanel` should be use to wrap the content of each individual tab used in `SelecatbleTabs`
 *
 */
function SelectableTabPanel(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "fade-in"
  }, void 0, children);
}
export default /*#__PURE__*/memo(SelectableTabPanel);